import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import ImageDeroulement from "../components/imageDeroulement"
import ImageConsultation from "../components/imageConsultation"
import ImageTeleconsultation from "../components/imageTeleconsultation"
import ImageVivalto from "../components/imageVivalto"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import SEO from "../components/seo"
import Share from "../components/share"
import { MdPhone, MdLocationOn } from "react-icons/md"
import { FaLink } from "react-icons/fa"

const ConsultationPage = () => (
  <Layout pathEn="/en/consultation/">
    <SEO
      title="Consultation de chirurgie de main, du coude et de l’épaule"
      description="Consultation à Paris 7e arrondissement de chirurgie orthopédiste spécialisée dans les pathologies de la main, du coude, de l'épaule et du poignet."
    />
    <Helmet>
      <link
        rel="alternate"
        hreflang="en"
        href={`https://www.docteurphilipperoure.com/en/consultation/`}
      />
    </Helmet>
    <ImageConsultation />
    <WrapperTitle>
      <Breadcrumb>
        <Link to="/">Accueil </Link>
      </Breadcrumb>
      <H1>Consultation de chirurgie de main, du coude et de l’épaule</H1>
      <p className="intro">
        Les consultations ont lieu principalement à l’Espace Médical Vauban.
        Situé dans le 7<sup>ème</sup> arrondissement de Paris, en face du dôme
        des Invalides, ce cabinet regroupe des médecins et des chirurgiens
        spécialisés dans la prise en charge des pathologies liées au sport et à
        l’arthrose.
      </p>
    </WrapperTitle>

    <Wrapper>
      <Row>
        <Col1>
          <H2>
            Déroulement d'une <span>consultation</span>
          </H2>
          <p>
            Lors de la consultation, je vous apporterai une expertise sur votre
            problème médical de la main ou du membre supérieur, éventuellement à
            l'aide d'<strong>examens complémentaires</strong> (radiographies,
            scanner, IRM...) et nous définirons ensemble 
            <strong>vos objectifs et impératifs</strong> personnels.
          </p>
          <p>
            Nous envisagerons ensuite les différentes possibilités de
            traitement, je vous préciserai pour chacune d'entre elles leurs
            avantages, inconvénients et risques potentiels. Nous définirons
            ensuite la 
            <strong>solution la mieux adaptée à votre situation</strong> et à
            votre attente.
          </p>
          <p>
            Il vous sera également remis un devis détaillé du 
            <strong>coût de intervention</strong> à transmettre à votre mutuelle
            ou votre assurance, vous permettant d'être pris en charge en
            totalité ou partiellement en fonction de votre contrat.
          </p>
          <p>
            Vous aurez naturellement toujours ensuite la possibilité de me
            rappeler ou de me revoir en consultation pour des explications
            complémentaires. Après votre intervention chirgicale, je vous
            reverrai également en consultation jusqu'à guérison ou stabilisation
            de votre état.
          </p>
        </Col1>
        <Col2>
          <ImageDeroulement />
        </Col2>
      </Row>

      <Row>
        <Col3>
          <iframe
            width="100%"
            height="350"
            src="https://www.youtube.com/embed/TRNa8Ovs4Vk?rel=0"
            allowfullscreen="allowfullscreen"
            frameborder="0"
            title="Présentation de l'Espace Médical Vauban à Paris"
            css={css`
              @media (max-width: 678px) {
                height: 190px;
              }
            `}
          />
        </Col3>

        <Col4>
          <H2>
            L'<span>Espace Médical Vauban</span> à Paris
          </H2>
          <p>
            Créé en 2006, l’
            <strong>
              <a
                href="http://www.vauban-medical.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                Espace M&eacute;dical Vauban
              </a>
            </strong>{" "}
            est un centre de consultations dédié à la Médecine et la Chirurgie
            du Sport ainsi qu’aux traitements de l’arthrose.
          </p>
          <p>
            Les praticiens qui constituent l’équipe médico-chirurgicale sont des{" "}
            <strong>spécialistes de l’appareil locomoteur</strong> reconnus
            depuis longtemps pour leur implication dans la prise en charge des
            sportifs de haut-niveau.
          </p>
          <p>
            Situé à l’angle de la Place Vauban et de l’avenue de Ségur, 
            <strong>face au dôme des Invalides</strong>, l’accès est simple en
            transport en commun et le parking aisé dans les rues environnantes.
          </p>
          <p>
            <Link to="/contact/">> Voir le plan d'accès</Link>
          </p>
        </Col4>
      </Row>

      <H2>
        <span>CHP</span> Montgardé
      </H2>
      <ImageVivalto />
      <p>
        Je suis &eacute;galement{" "}
        <strong>membre du service Urgence Main Val de Seine</strong> au{" "}
        <a
          href="https://chp-montgarde.fr/"
          target="blank"
          rel="noreferrer noopener"
        >
          CHP Montgard&eacute;
        </a>{" "}
        (Vivalto Santé) dans les Yvelines. Cette unité est spécialisée dans la
        chirurgie du membre supérieur, et en particulier la prise en charge des
        urgences de la Main, elle est agrée par la Fédération Européenne des
        Services d’Urgence Main (
        <a
          href="https://www.fesum.fr/"
          target="blank"
          rel="noreferrer noopener"
        >
          FESUM
        </a>
        ). Les{" "}
        <Link to="/chirurgie-main/urgence-main/">urgences de la main</Link> y
        sont accueillies <strong>24h/24</strong> par un médecin urgentiste et
        opérées par un des chirurgiens de l’équipe, spécialisé en{" "}
        <Link to="/chirurgie-main/">chirurgie de la main</Link> et
        microchirurgie.
      </p>
      <p>
        J’y assure consultation et interventions chirurgicales les 
        <strong>mercredi</strong> et certains <strong>lundi</strong>, le plateau
        technique me permet d’y réaliser l’ensemble des interventions sur le
        membre supérieur, y compris au niveau de l’épaule et du coude.
      </p>
      <p>
        Mes <strong>assistantes</strong> Sabah, Frédérique, Cindy, Morgane et
        notre infirmière Justine vous accueilleront et vous renseigneront, y
        compris lorsque je ne suis pas présent sur le site. Mes 
        <strong>collègues</strong>, les Docteurs Abadie, Barbato, Beauthier,
        Benayoun, Ghafanzari et Werther, pourront vous recevoir en cas de
        problème urgent en mon absence.
        <br />
        &nbsp;
      </p>
      <Row>
        <Col1>
          <H2>
            <span>Vidéo-consultation</span> avec Doctolib
          </H2>
          <p>
            Le docteur Philippe Roure propose un service de{" "}
            <strong>vidéo-consultation</strong> via le site{" "}
            <a
              href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
              rel="noreferrer noopener"
            >
              Doctolib
            </a>
            . Ce service permet d’avoir facilement accès à l’expertise du Dr
            Philippe Roure, pour une première consultation diagnostique, ou une
            consultation de suivi, quel que soit l’endroit où vous vous trouvez.
          </p>
          <p>
            Avant votre vidéo-consultation, vous pourrez faire parvenir au Dr
            Roure vos <strong>examens complémentaires</strong> par le système
            Doctolib. Les <strong>ordonnances</strong> pourront également vous
            être envoyées à l’issu de la consultation.
          </p>
          <p>
            Une <strong>consultation complémentaire présentielle</strong> pourra
            être cependant nécessaire dans un deuxième temps en fonction de
            votre problème.
          </p>
          <p>
            Les modalités pratiques de la vidéo consultation vous seront
            détaillées en cliquant sur l’onglet «&nbsp;Vidéo&nbsp;» dans la
            prise de rendez-vous{" "}
            <a
              href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
              rel="noreferrer noopener"
            >
              Doctolib
            </a>
            .
          </p>
          <p>
            <Link to="/actus/video-consultation/">> En savoir plus</Link>
          </p>
        </Col1>
        <Col2>
          <ImageTeleconsultation />
        </Col2>
      </Row>
      <Row
        css={css`
          margin-top: 55px;
        `}
      >
        <Col5>
          <h3
            css={css`
              opacity: 0.8;
              font-size: 1.45em;
            `}
          >
            Coordonnées
          </h3>
          <p
            css={css`
              font-size: 0.93em;
              line-height: 1.85em;
            `}
          >
            UMVS - CHP Montgard&eacute;
            <br />
            <MdLocationOn /> 32, rue du Montgard&eacute; - 78410 Aubergenville
            <br />
            <MdPhone
              css={css`
                font-size: 1.1em;
                margin-top: 3px;
              `}
            />{" "}
            01 30 95 12 20
            <br />
            <a
              href="https://chp-montgarde.fr/"
              target="blank"
              rel="noreferrer noopener"
              css={css`
                border-bottom: none;
              `}
            >
              <FaLink
                css={css`
                  font-size: 0.84em;
                `}
              />{" "}
              Site internet
            </a>
          </p>
        </Col5>
        <Col6>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10479.476425222223!2d1.8467521!3d48.9559782!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6fcc38e98c90d90!2sCentre+Hospitalier+Priv%C3%A9+du+Montgard%C3%A9!5e0!3m2!1sfr!2sus!4v1558378957413!5m2!1sfr!2sus"
            width="100%"
            height="225"
            title="Plan d'accés au CHP Montgardé dans le 78"
            frameborder="0"
            allowfullscreen
          />
        </Col6>
      </Row>

      <Share
        slug="https://www.docteurphilipperoure.com/consultation/"
        title="Consultation de chirurgie orthopédique - Dr Philippe Roure"
      />
    </Wrapper>
  </Layout>
)

export default ConsultationPage

const WrapperTitle = styled.div`
  background-color: white;
  width: 78%;
  margin: 0 auto;
  border-radius: 7px;
  padding: 1.5em 2em 0.9em;
  margin-bottom: 45px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1024px) {
    width: 100%;
    box-sizing: border-box;
    padding: 1em 1em 0.5em;
    margin-bottom: 25px;
    border-radius: 0 0 7px 7px;
  }
`
const Breadcrumb = styled.div`
  color: #e6ae48;
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  font-size: 2.1em;
  @media (max-width: 678px) {
    font-size: 1.82em;
    line-height: 1.1em;
  }
`

const Wrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 0.5em;
  padding: 2.25em 2em 1em 2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 678px) {
    border-radius: 7px;
    padding: 1em;
  }
`

const H2 = styled.h2`
  font-weight: 400;
  line-height: 1.38em;
  font-size: 1.9em;
  margin-block-start: 0;
  span {
    font-weight: 800;
  }
  @media (max-width: 678px) {
    font-size: 1.7em;
    line-height: 1.3em;
  }
`

const Row = styled.div`
  display: flex;
  margin: 15px 0 55px;
  clear: both;
  @media (max-width: 678px) {
    flex-wrap: wrap;
    margin: 0px 0 30px;
  }
`

const Col1 = styled.div`
  flex: 69%;
  padding-right: 10px;
  @media (max-width: 678px) {
    padding-right: 0;
    flex-basis: 100%;
  }
`

const Col2 = styled.div`
  flex: 31%;
  padding-left: 10px;
  @media (max-width: 678px) {
    padding: 0;
    flex-basis: 100%;
  }
`

const Col3 = styled.div`
  flex: 50%;
  padding-right: 10px;
  @media (max-width: 678px) {
    order: 2;
    flex-basis: 100%;
  }
`

const Col4 = styled.div`
  flex: 50%;
  padding-left: 10px;
  @media (max-width: 678px) {
    order: 1;
    flex-basis: 100%;
    padding: 0;
  }
`

const Col5 = styled.div`
  flex: 30%;
  @media (max-width: 678px) {
    order: 2;
    flex-basis: 100%;
  }
`

const Col6 = styled.div`
  flex: 70%;
  @media (max-width: 678px) {
    order: 1;
    flex-basis: 100%;
  }
`
